<template>
  <div class="">

  </div>
</template>
<script>
import { nanoid } from 'nanoid'
import { singleHomeServer } from "@/common/api-config";
export default {
  data() {
    return {
      Univeral_Links:'https://www.douban.com/doubanapp/dispatch?uri=/movie/5327268&from=mdouban&page=movie&model=B&copy=1&channel=card_movie&download=1'
    };
  },
  created() {
    //  window.location.href= '/getBrandByHW'
    window.location.href= 'https://www.malink.cn/'
    /*
      逻辑1
      if(ajax=>链接是否生效){
        ajax 页面埋点
        ajax=>请求玩咖接口，拿链接应用信息
          if(是否ios){
            直接跳转 Univeral Links
          }else{
            ajax=>请求厂商接口，拿厂商信息
              if(某厂商响应信息){
                ajax 事件埋点
                ajax=>请求厂商接口，拿厂商AppLink并跳转
              }else{
                if(开发者是否填写落地页){
                  跳转落地页
                }else{
                  跳转兜底页
                }
              }
          }
      }else{
        跳去错误页 
      }
    */

    /*
      逻辑2
      applink通用链接唤起逻辑
      ajax => 请求玩咖接口，拿开发者官网填的信息（其中这里有各厂商拼接好参数的厂商h5长链）
        if(链接是否禁用或冻结){
          if(是否IOS){
            数据埋点(device-detector-js取的设备信息) => Univeral Links
          }else{
            识别厂商信息[
              方案：vivo、小米能实现系统Service监控返回对应厂商设备信息，OPPO和华为通过UA来识别厂商
            ] => if(vivo|小米){
                  数据埋点(厂商给的设备信息) => 跳转(vivo|小米)：h5长链
                }else{
                  if(UA == OPPO){
                    数据埋点(device-detector-js取的设备信息) => 跳转OPPO：h5长链
                  }else if(UA == 华为){
                    数据埋点(device-detector-js取的设备信息) => 跳转华为：app的deeplink 或者 厂商h5长链
                  }else{
                    if(开发者是否填写落地页){
                      数据埋点(device-detector-js取的设备信息) => 跳转开发者填写的落地页
                    }else{
                      数据埋点(device-detector-js取的设备信息) => 跳转默认兜底页
                    }
                  }
                }
          }
        }else{
          数据埋点(device-detector-js取的设备信息)=> 跳去错误引导页 
        }
    */


    /*
      逻辑3
      if(UA == IOS){
        数据埋点(device-detector-js取的设备信息) => Univeral Links
      }else if(UA == 华为){
        数据埋点(device-detector-js取的设备信息) => 跳转华为：app的deeplink 或者 厂商h5长链
      }else{
        识别厂商信息接口[ vivo、小米能实现系统Service监控返回对应厂商设备信息] =>{
          数据埋点(厂商给的设备信息) => 跳转(vivo|小米)：h5长链
        }
      }
      需要讨论：
      一、deeplink、厂商h5长链是url怎么给？
      1、url?参数带 
        优势：不用再发起请求,减少了流量，减少了响应时间，减少了异常情况，
        缺点：url字符长度不能过长,容易被篡改
      2、cookie 设置 
        优势：不用再发起请求,减少了流量，减少了响应时间，减少了报错异常，
        缺点：也可以背篡改，当得使用具体调试代理工具
      3、接口拿
        优势：安全，可以防篡改，
        缺点：多流量，多响应时间，多异常情况
      二、华为设备deeplink直接唤起app 需要上报数据吗？
      预计工时(3天)： 
      1、业务逻辑 
      2、调研华为设备H5页面是否成功拉起已安装的app可靠方案
      3、数据上报统计
    */









    // this.queryAppInfo().then(data=>{
    //     if(this.utils.getTerminal() == 'ios'){
    //       // window.location.href = data.Univeral_Links;
    //     }else{
    //       // this.queryMemberInfo().then(data=>{
    //       //   if(是小米、OPPO、vivo、华为){
    //       //     数据埋点(厂商给的设备信息)=> 跳转厂商H5
    //       //   }else{
    //       //     if(开发者是否填写落地页){
    //       //       数据埋点(device-detector-js取的设备信息)=> 跳转开发者填写的落地页
    //       //     }else{
    //       //       数据埋点(device-detector-js取的设备信息)=> 跳转默认兜底页
    //       //     }
    //       //   }
    //       // })
    //     }
    // })
  },
  methods: {
    //获取应用信息
    queryAppInfo() {
      return new Promise((resolve)=>{
        singleHomeServer.queryAppInfo().then(res=>{
          if (res["code"] == 0 && res.data) {
            resolve(res["data"]);
          } else {
            this.submitLog();
          }
        })
      });
    },
    //获取厂商信息
    queryMemberInfo() {
      return new Promise((resolve)=>{
        singleHomeServer.queryMemberInfo().then(res=>{
          if (res["code"] == 0 && res.data) {
            resolve(res["data"]);
          } else {
            this.submitLog();
          }
        })
      });
    },
    //上报日志
    submitLog(memberInfo={}){
      return new Promise((resolve)=>{
        try{
          let device = JSON.parse(localStorage.getItem("device"));
          let screenWidth = window.screen.width;
          let screenHeight = window.screen.height;
          let params = {

          };
          singleHomeServer.submitLog(params).then(res=>{
            if (res["code"] == 0 && res.data) {
              resolve(res["data"]);
            } else {
              this.error_report(params);
            }
          })
        }catch(e){
          // console.error(e)
        }
      });
    },
    //上报错误缓存
    error_report(params={}){
      params.day = new Date().getTime();
      params.len = 0;
      // 判断日期和数量
      // 判断日期和数量
      err_info.day !== day ? err_info.len = 0 : null;
      err_info.len < 50 ? ++err_info.len : null;

      //  大于 50 不发送
      if( err_info.len > 50 ) return


      localStorage.setItem(params.day, params);
    },
    //传参混淆签名
    create_sign(params={}) {
      let json = this.utils.sort_ASCII(params);//ASCII码从小到大排序
      let paramStr = decodeURIComponent(this.utils.jsonToParamStr(json));//转成拼接参数（timestamp=1616061217031&url=/home/news/info&uuid=Fo05gxOIAXOh3qen8Km3W）
      return md5(paramStr);//MD5加密
    },
  }
};
</script>
<style lang="scss" scoped>
</style>
